import { Injectable } from '@angular/core';
import { AuthHttp } from '../http/http.service';
import { environment } from '../../../environments/environment';
import { AuthenticationService } from '../auth/authentication.service';
import { asError, requestWithResponse } from '../http/request-with-response';
@Injectable()
export class FaqService {
  constructor(private readonly http: AuthHttp, private readonly authService: AuthenticationService) {}
  public selectFaqLanguage: string;
  getFaq(descripcion: any, language: any) {
    return requestWithResponse(this.http.post(`${environment.apiURLs.private}/faq/getFaq`, { descripcion, language }),
      () => undefined,
      errorResponse => this.toError(errorResponse));
  }
  set(descripcion: any, language: any, faq: any) {
    return requestWithResponse(this.http.post(`${environment.apiURLs.private}/faq/set`, { descripcion, language, faq }),
      () => undefined,
      errorResponse => this.toError(errorResponse));
  }

  private toError(errorResponse: unknown): Error {
    return asError(errorResponse);
  }
}
